import { Box, Flex } from '@modusign/design-system';

import { ContextMenuRow, ContextMenuRowDivider } from '@app/components/ContextMenu';

interface TextFieldContextMenuFormatRowProps {
  label: string;
  contextMenu: React.ReactNode;
  onInputClick: () => void;
}

export function TextFieldContextMenuFormatRow({
  contextMenu,
  label,
  onInputClick,
}: TextFieldContextMenuFormatRowProps) {
  return (
    <>
      <ContextMenuRowDivider />
      <ContextMenuRow>
        <Flex alignItems="center" flexDirection="row" justifyContent="space-between">
          <b>형식</b>
          <Flex flexDirection="column" height="32px" position="relative" width="120px">
            <Box
              alignItems="center"
              as="button"
              backgroundColor="white"
              borderColor="#d2d2d2"
              borderStyle="solid"
              borderWidth="1px"
              color="#292929"
              data-testid="text-field-font-select"
              display="flex"
              height="100%"
              justifyContent="space-between"
              px={4}
              value="텍스트"
              width="100%"
              onClick={onInputClick}
            >
              {label}
              <Box
                borderBottomColor="black"
                borderBottomWidth={0}
                borderLeftColor="transparent"
                borderLeftWidth="4px"
                borderRightColor="transparent"
                borderRightWidth="4px"
                borderStyle="solid"
                borderTopColor="black"
                borderTopWidth="6px"
                height={0}
                width={0}
              />
            </Box>
            {contextMenu}
          </Flex>
        </Flex>
      </ContextMenuRow>
    </>
  );
}
